import React from 'react';
import { FaIdCard, FaFileAlt, FaCalendarAlt, FaChartBar } from 'react-icons/fa';

interface SicorReportCardProps {
    item: any;
    onClick?: () => void;
    className?: string;
}

const SicorReportCard: React.FC<SicorReportCardProps> = ({ item, onClick, className = '' }) => {
    const renderReportsPerYear = (reportsPerYear: { [year: string]: number }) => {
        if (!reportsPerYear || Object.keys(reportsPerYear).length === 0) {
            return <span className="text-gray-400 text-xs">Nenhum dado</span>;
        }

        return (
            <div className="flex flex-wrap gap-1">
                {Object.entries(reportsPerYear)
                    .sort(([a], [b]) => b.localeCompare(a))
                    .slice(0, 3)
                    .map(([year, count]) => (
                        <span 
                            key={year}
                            className="inline-flex items-center px-2 py-1 rounded-full text-xs bg-blue-100 text-blue-800"
                        >
                            {year}: {count}
                        </span>
                    ))}
                {Object.keys(reportsPerYear).length > 3 && (
                    <span className="text-xs text-gray-500">
                        +{Object.keys(reportsPerYear).length - 3} anos
                    </span>
                )}
            </div>
        );
    };

    return (
        <div 
            className={`bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow duration-200 p-4 cursor-pointer border border-gray-200 ${className}`}
            onClick={onClick}
        >
            {/* Header com documento */}
            <div className="mb-3 pb-3 border-b border-gray-100">
                <div className="flex items-center space-x-2">
                    <FaIdCard className="text-orange-500 text-lg" />
                    <div className="flex-1">
                        <p className="text-xs text-gray-600 font-medium">Documento</p>
                        <p className="text-sm font-bold text-gray-900" title={item.documentFormatted}>
                            {item.documentFormatted}
                        </p>
                    </div>
                </div>
            </div>

            {/* Estatísticas */}
            <div className="grid grid-cols-2 gap-3 mb-3">
                <div className="flex items-center space-x-2">
                    <FaFileAlt className="text-green-500 text-sm" />
                    <div>
                        <p className="text-xs text-gray-500">Total Relatórios</p>
                        <p className="text-sm font-semibold text-gray-900">{item.totalReports}</p>
                    </div>
                </div>
                <div className="flex items-center space-x-2">
                    <FaCalendarAlt className="text-blue-500 text-sm" />
                    <div>
                        <p className="text-xs text-gray-500">Total Anos</p>
                        <p className="text-sm font-semibold text-gray-900">{item.totalYears}</p>
                    </div>
                </div>
            </div>

            {/* Relatórios por ano */}
            <div className="space-y-2">
                <div className="flex items-center space-x-2">
                    <FaChartBar className="text-purple-500 text-sm" />
                    <p className="text-xs text-gray-500 font-medium">Relatórios por Ano</p>
                </div>
                <div className="pl-6">
                    {renderReportsPerYear(item.reportsPerYear)}
                </div>
            </div>
        </div>
    );
};

export default SicorReportCard;
